// @services/clients/PaymentClient.ts
import type { PaymentClient as InteropPaymentClient } from '@ps-bridge/clients/payment';
import type {
    DemographicInformation,
    PaymentError,
    PromoCode,
    PromoCodeResponse,
    SubscriptionPlan,
} from '@ps-bridge/models/core/dataContracts';
import type { TaskEitherTs } from '@ps-bridge/interop';
import { taskEitherFromRaw } from '@utils/effects/branded';
import type { Ok } from '@ps-bridge/ok';

export interface PaymentClient {
    readonly getPublishableKey: TaskEitherTs<PaymentError, string>;
    readonly setupIntent: (
        subscriptionPlan: SubscriptionPlan,
    ) => TaskEitherTs<PaymentError, string>;
    readonly cancelSubscription: TaskEitherTs<PaymentError, Ok>;
    readonly validatePromoCode: (promoCode: PromoCode) => TaskEitherTs<PaymentError, PromoCodeResponse>;
    readonly submitDemographicInformation: (
        promoCode: PromoCode,
        demographicInfo: DemographicInformation,
    ) => TaskEitherTs<PaymentError, Ok>;
    readonly submitSquareCardNonce: (nonce: string) => TaskEitherTs<PaymentError, Ok>;
}

export const fromInteropPaymentClient = (client: InteropPaymentClient): PaymentClient => ({
    getPublishableKey: taskEitherFromRaw(client.getPublishableKey),
    setupIntent: (subscriptionPlan) => taskEitherFromRaw(client.setupIntent(subscriptionPlan)),
    cancelSubscription: taskEitherFromRaw(client.cancelSubscription),
    validatePromoCode: (promoCode) => taskEitherFromRaw(client.validatePromoCode(promoCode)),
    submitDemographicInformation: (promoCode, demographicInfo) =>
        taskEitherFromRaw(client.submitDemographicInformation(promoCode)(demographicInfo)),
    submitSquareCardNonce: (nonce) => taskEitherFromRaw(client.submitSquareCardNonce(nonce)),
});
